<template>
    <div class="my-info-basic">
        <el-row class="top">
            <el-col :span="11" class="left">
                <p class="leftp1">
                    {{ $t("warp.hello") }}，
                    <span>{{ userInfo.name }}</span>
                    <label></label>
                    <span v-if="isAmjs" class="amjs-vip" @click="openVip">
                        <img :src="require('../../../assets/images/amjs/vip'+ (userInfo.viplv-1)+'.png')">
                    </span>
                    <span v-else class="vipBox" @click="openVip">
                        <img loading="lazy"
                        v-lazy="require('../../../assets/images/my/vip.png')"/>
                        <i>{{+userInfo.viplv === 1 ? '普通用户' : 'VIP' + (userInfo.viplv-1)}}</i>
                    </span>
                    
                    <el-button
                        size="mini"
                        @click="$router.push({ path: '/my/security/login' })"
                    >{{ $t("base.changePsw") }}</el-button>
                </p>
                <p class="leftp2">
                    {{ $t("base.safetyLevel") }}
                    <el-progress color="#f7b800" :percentage="onNum" :format="format"></el-progress>
                </p>
                <ul class="leftp3 el-row">
                    <router-link to="/my/info/account">
                        <li :class="{ ok: userInfo.phone }">
                            <span></span>
                            {{ $t("base.phoneBind") }}
                        </li>
                    </router-link>
                    <router-link to="/my/info/account">
                        <li :class="{ ok: userInfo.email }">
                            <span></span>
                            {{ $t("base.emailBind") }}
                        </li>
                    </router-link>
                    <router-link to="/my/security/capital">
                        <li :class="{ ok: userInfo.withdrawPassWordState }">
                            <span></span>
                            {{ $t("base.moneyPsw") }}
                        </li>
                    </router-link>
                    <router-link to="/my/info/bankCard">
                        <li :class="{ ok: bankArr.length }">
                            <span></span>
                            {{ $t("base.bankcardBind") }}
                        </li>
                    </router-link>
                </ul>
            </el-col>
            <!-- <el-col :span="10" class="middle">
                <p>{{ $t("base.vipLevel") }}</p>
                <p class="middlep2">
                    <span class="vipStart">{{userInfo.nowMemberVip.vipShow}}</span>

                    <el-progress :show-text="false" color="#f7b800" :percentage="percent"></el-progress>
                    <span class="vipEnd">{{userInfo.nextMemberVip.vipShow}}</span>
                </p>
                <div class="middlep3" v-if="this.userInfo.nextMemberVip.vipExp">
                    {{ $t("base.distance") }} {{userInfo.nextMemberVip.vipShow}}
                    {{ $t("base.short") }}
                    <label>{{ dataHandler(userInfo.nextMemberVip.vipExp,userInfo.memberExp) }}</label>
                    {{ $t("base.experience") }}
                    <el-tooltip popper-class="basicTooltip" effect="light" placement="top">
                        <div slot="content">
                            <p>
                                {{ $t("base.system") }}
                                <span>{{ $t("base.nextWeek") }}</span>
                            </p>
                            <p>{{ $t("base.clear") }}</p>
                        </div>
                        <img loading="lazy" v-lazy="require('../../../assets/images/my/inquiry.png')" />
                    </el-tooltip>
                </div>

                <div class="middlep3" v-else>{{ $t("base.toppest") }}</div>
            </el-col> -->
            <el-col :span="5" class="right">
                <p class="waterText">
                    {{ $t("myPage.water") }}:￥
                    {{ $common.setNumFixed(rebateNum, 2) }}
                </p>
                <span @click="openFanBut">{{ $t("myPage.get") }}</span>
            </el-col>
        </el-row>
        <div class="moneyBox el-row">
            <p class="titleM">{{ $t("accountPage.accountMoney") }}</p>
            <div class="flex-box">
                <div class="btnM btn-money">
                    <span>
                        <span class="red">
                            ￥{{
                            $common.setNumFixed(userInfo.totalBalance, 2)
                            }}
                        </span>
                        {{ $t("accountPage.element") }}
                    </span>
                    <img loading="lazy"
                        @click="mygame(true)"
                        v-lazy="require('../../../assets/images/qiqi/refresh.png')"
                        class="refreshImg"
                        :class="{ shuaActive: refreshImgStart }"
                        alt
                    />
                </div>
                <div class="btnM m-back" @click="onMergeGame">{{ $t("accountPage.collection") }}</div>
            </div>
        </div>
        <p class="gameTitle">
            <span></span>
            {{ $t("accountPage.game") }}
        </p>
        <ul class="gamelist el-row">
            <li v-for="item in gamelist" :key="item.id">
                <p class="gamep1">{{ item.vendorName }}</p>
                <p
                    v-if="item.operation"
                    class="gamep1"
                    :class="{ moneyColor: item.totalMoney != 0 }"
                >￥{{ item.totalMoney.toFixed(2) }}</p>
                <p v-if="!item.operation" class="gamep1">{{ $t("accountPage.hand") }}</p>
            </li>
        </ul>
        <div class="myTitle1">
            <span></span>
            {{ $t("personalPage.personalData") }}
        </div>
        <ul class="bottom el-row">
            <li>
                <h2>{{ $t("personalPage.nickname") }}</h2>
                <p>{{ userInfo.nickname }}</p>
            </li>
            <li>
                <h2>{{ $t("registerPage.sex") }}</h2>
                <p>
                    {{
                    userInfo.sex == 1
                    ? $t("registerPage.male")
                    : $t("registerPage.female")
                    }}
                </p>
            </li>
            <li>
                <h2>{{ $t("personalPage.phone") }}</h2>
                <p>{{ $utils.hideMiddle(userInfo.phone) }}</p>
            </li>
            <li>
                <h2>{{ $t("personalPage.email") }}</h2>
                <p>{{ $utils.hideMiddle(userInfo.email) }}</p>
            </li>
            <li>
                <h2>{{ $t("personalPage.qq") }}</h2>
                <p>{{ $utils.hideMiddle(userInfo.qq) }}</p>
            </li>
        </ul>
        <TimeDiscount ref="refTimeDiscount"></TimeDiscount>
        <rebate ref="refRebate" :userfan="userfan" @onbackFan="onbackFan"></rebate>
        <vipLv ref="refVip"></vipLv>
        <el-dialog
            :visible.sync="amjsVipShow"
            width="500px"
            :append-to-body="true"
            class="amjsVipBox"
            :show-close="true"
        >
        <div><img loading="lazy" v-lazy="require('../../../assets/images/amjs/vip.png')"></div>
        </el-dialog>
    </div>
</template>
<script>
import VipLv from "./vipLv.vue"
import TimeDiscount from "../../../components/TimeDiscount/TimeDiscount";
import rebate from "../../../components/Rebate/Rebate";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            gamelist: [],
            achieve: 0, //距离下一个等级的差额
            percent: 0.0, //百分比
            userfan: {},
            OneKey: false,
            refreshImgStart: false,
            amjsVipShow: false,
            isAmjs: false
        };
    },
    components: {
        TimeDiscount,
        rebate,
        VipLv
    },
    computed: {
        rebateNum: function () {
            return this.userfan.rebateAmount || '--/--';
        },
        ...mapGetters(["userInfo", "bankArr"]),
        onNum() {
            let _num = 0;
            this.userInfo.phone && (_num += 25);
            this.userInfo.email && (_num += 25);
            this.userInfo.withdrawPassWordState && (_num += 25);
            this.bankArr.length && (_num += 25);
            return _num;
        }
    },
    created() {
        this.mygame();
        //获取会员列表
        this.getVipList();
        this.getuserFanshui();
        this.isAmjs = window.projectImgUrl === 'amjs' ? true : false;
    },
    methods: {
        openVip() {
            if (this.isAmjs) {
                this.amjsVipShow = true;
            } else {
                this.$refs.refVip.openAlert();
            }
        },
        dataHandler(a, b) {
            return a - b;
        },
        //一键归集
        onMergeGame() {
            if (this.OneKey) {
                setTimeout(() => {
                    this.OneKey = false;
                }, 10000);
                this.$message.error(this.$t("accountPage.warning"));
                return;
            }
            this.OneKey = true;
            let option = {
                clientId: this.$common.getUser().tenant_id, //tenant_id
                clientIp: this.$config.clientIp,
                memberId: this.$common.getUser().user_id, //userid
                username: this.$common.getUser().username
            };
            this.$http.post(this.$api.oneKeyBalance, option, true).then(res => {
                if (res.code == 0) {
                    this.$message.success(this.$t("accountPage.handRes"));
                    this.mygame();
                }
            });
        },
        getVipList() {
            var _this = this;
            // this.$nkhttp.http(_this.$api.getVipList, "", "post", data => {
            //     _this.vipList = data;
            //     //差额
            //     let nextLv = _this.userInfo.viplv + 1;
            //     let nextList = _this.vipList.filter(item => {
            //         return nextLv == item.gradeId;
            //     });
            //     let nextlevel = nextList[0].charge;
            //     _this.achieve =
            //         nextlevel - _this.userInfo.rechargeAmount <= 0
            //             ? 0
            //             : nextlevel - _this.userInfo.rechargeAmount;
            //     //百分比
            //     let upperlevel = 0;
            //     if (_this.userInfo.viplv == 1) {
            //         upperlevel = 0;
            //     } else {
            //         let upperList = this.vipList.filter(item => {
            //             return this.userInfo.viplv == item.gradeId;
            //         });
            //         upperlevel = upperList[0].charge;
            //     }
            //     if (this.userInfo.rechargeAmount - upperlevel <= 0) {
            //         this.percent = 0;
            //     } else if (this.userInfo.rechargeAmount - nextlevel >= 0) {
            //         this.percent = 100;
            //     } else {
            //         this.percent =
            //             ((this.userInfo.rechargeAmount - upperlevel) /
            //                 (nextlevel - upperlevel)) *
            //             100;
            //     }
            // });
            // this.percent = parseInt(
            //     (this.userInfo.memberExp / this.userInfo.nextMemberVip.vipExp) *
            //         100
            // );
            // if (!this.userInfo.nextMemberVip.vipExp) {
            //     //满级的时候
            //     this.percent = 100;
            // }
        },
        currentLv(val) {
            //现在会员等级
            if (!val.startsWith("lv")) {
                return this.$t("base.commonUser");
            }
        },
        format(percentage) {
            if (percentage < 60) return this.$t("base.lowLevel");
            else if (percentage > 79) return this.$t("base.highLevel");
            else return this.$t("base.middleLevel");
        },
        mygame(refour = false) {
            this.refreshImgStart = true;
            let option = {
                clientId: this.$common.getUser().tenant_id, //tenant_id
                clientIp: this.$config.clientIp,
                memberId: this.$common.getUser().user_id, //userid
                username: this.$common.getUser().username
            };
            this.$http
                .post(this.$api.getGameMoneyList, option, true)
                .then(res => {
                    this.refreshImgStart = false;
                    if (res.code == 0 && res.data) {
                        this.$store.commit("updataUserInfo", res.data);
                        let list = res.data.totalBalanceDetail;

                        this.gamelist = list.filter(item => {
                            return item.type != 1;
                        });
                        if (refour) {
                            this.$message.success(
                                this.$t("accountPage.Refresh")
                            );
                        }
                    }
                });
        },
        onbackFan() {
            this.getuserFanshui();
        },
        // 领取返利打开弹框
        openFanBut() {
            if (this.userfan.rebateAmount < this.userfan.rebateDown) {
                this.$message({
                    message: this.$t("myPage.tipErr"),
                    type: "warning"
                });
                return;
            }

            this.$refs.refRebate.dialogVisible = true;
        },
        // 获取返利
        getuserFanshui(type) {
            this.$http
                .get(
                    this.$api.getRebateAmount +
                        this.$cache.get("set_user").user_id
                )
                .then(res => {
                    if (res.code == 0) {
                        this.userfan = res.data;
                        if (type) {
                            this.$message({
                                message: this.$t("myPage.success"),
                                type: "success"
                            });
                        }
                    } else {
                        if (type) {
                            this.$message({
                                message: this.$t("myPage.failure"),
                                type: "warning"
                            });
                        }
                    }
                });
        }
    }
};
</script>

<style>
.el-tooltip__popper.basicTooltip {
    border: 1px solid #e8e8e8;
    color: #666;
    padding: 5px 10px;
    line-height: 18px;
}
.el-tooltip__popper.basicTooltip span {
    color: #f01924;
    margin-left: 5px;
}
</style>

<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.my-info-basic {
    .moneyBox {
        border-bottom: 1px solid #e8e8e8;
        padding: 20px 0;
        .flex-box {
            display: flex;
        }
        .titleM {
            font-size: 14px;
            // font-weight: bold;
        }
        .btnM {
            display: inline-block;
            border-radius: 8px;
            border: 1px solid #e8e8e8;
            text-align: center;
            line-height: 40px;
            min-width: 1.2rem;
            margin-right: 20px;
            margin-top: 10px;
            cursor: pointer;
            &.m-back {
                background-color: #ff3a2b;
                color: #fff;
                &:hover {
                    opacity: .9;
                }
            }
            .red {
                color: #ff3a2b;
                font-size: 18px;
            }
        }
        .btn-money {
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 0 10px;
        }
        .refreshImg {
            width: 20px;
            margin-left: 20px;
        }
        .shuaActive {
            animation: mymove 1.25s linear infinite;
            -moz-animation: mymove 1.25s linear infinite;
            /* Firefox */
            -webkit-animation: mymove 1.25s linear infinite;
            /* Safari and Chrome */
            -o-animation: mymove 1.25s linear infinite;
            /* Opera */
        }

        @keyframes mymove {
            0% {
                -webkit-transform: rotate(0deg);
            }

            100% {
                -webkit-transform: rotate(720deg);
            }
        }
    }
    .gameTitle {
        font-size: 14px;
        padding-top: 10px;
        span {
            border-left: 2px solid red;
            margin-right: 4px;
        }
    }
    .top {
        font-size: 12px;
        border-bottom: 1px solid #e1e1e1;
        padding-bottom: 15px;
        .left {
            margin: 15px 0;
            border-right: 1px solid #e6e6e6;
            .leftp1 {
                font-size: 15px;
                span {
                    color: #06f;
                    margin-left: 10px;
                    margin-right: 10px;
                }
                .vipBox {
                    cursor: pointer;
                    color: #8b5b3f;
                    padding: 2px 10px;
                    background-color: #f5d7a8;
                    border-radius: 10px;
                }
                img {
                    margin-right: 3px;
                    vertical-align: baseline;
                    width: 18px;
                }
                .amjs-vip {
                    img {
                        width: 100px;
                        vertical-align: middle;
                        cursor: pointer;
                    }
                }
            }
            .leftp2 {
                margin-top: 5px;
                .el-progress {
                    width: 70%;
                    margin-left: 20px;
                    display: inline-block;
                }
            }
            .leftp3 {
                display: flex;
                margin-top: 14px;
                li {
                    cursor: pointer;
                    line-height: 24px;
                    color: #bbb;
                    margin-right: 10px;
                    span {
                        display: inline-block;
                        height: 18px;
                        width: 18px;
                        background: url(../../../assets/images/my/myinfostate.png)
                            no-repeat;
                        background-position: -18px 0;
                        background-size: cover;
                        vertical-align: middle;
                    }
                    &.ok {
                        color: #666;
                        span {
                            background-position: 0 0;
                        }
                    }
                }
            }
        }
        .middle {
            margin-top: 20px;
            padding-left: 28px;
            padding-bottom: 16px;
            margin-right: 1%;
            border-left: 1px solid #e6e6e6;
            border-right: 1px solid #e6e6e6;
            .el-progress {
                width: 200px;
                display: inline-block;
                margin: 0 10px;
            }
            span {
                width: 60px;
                height: 18px;
                line-height: 18px;
                color: #fff;
                text-align: center;
                border-radius: 20px;
                display: inline-block;
            }
            .vipStart {
                background: #ff3a2b;
            }
            .vipEnd {
                background: #bdb6ba;
            }
            .middlep2 {
                margin-top: 10px;
            }
            .middlep3 {
                padding-top: 16px;
                color: #999;
                label {
                    color: #f33;
                }
                img {
                    width: 20px;
                    height: 20px;
                    margin-left: 20px;
                }
            }
        }
        .right {
            float: left;
            width: 19%;
            text-align: center;
            padding-top: 20px;
            .waterText {
                font-size: 14px;
                margin: 10px;
            }
            span {
                display: inline-block;
                border: none;
                color: #fff;
                font-size: 14px;
                background: #ff3a2b;
                box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
                border-radius: 100px;
                width: 80px;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
            }
        }
    }
    .bottom {
        li {
            width: 50%;
            line-height: 54px;
            float: left;
            h2 {
                float: left;
                min-width: 20%;
                padding-right: 10px;
                font-size: 13px;
                font-weight: 500;
                color: #444;
            }
            p {
                color: #888;
            }
        }
    }
}
.amjsVipBox {
    font-size: 10px;
    ::v-deep.el-dialog__headerbtn .el-dialog__close {
        font-size: 30px !important;
        color: #313131 !important;
    }
}
</style>